import React, { useEffect, useRef, useState, useContext } from "react";
import { FaArrowLeft, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import buildLink from "../../../urls";
import axios from "axios";
import MessageAlert from "../../../components/messageAlert";
import { PlaySounds } from "../../../functions/playSounds";
import hocStarredPage from "../../../components/hocStarredPage";
import {
  CompanyContext,
  CompanyProvider,
} from "../../../contexts/companyCotext";
import { getDetectedOrderType } from "../../../functions/getDetectedOrderType";
import { axiosServer } from "../../../axiosServer";

const RestockOrder = () => {
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const [stateCom] = useContext(CompanyContext);
  const orderId = useRef(null);
  const Id = useRef(null);
  const returnOrderId = useRef(null);
  const barcodeValue = useRef(null);
  const adressValue = useRef(null);
  const [loading, setLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState([]);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [message, setMessage] = useState("");
  const [address, setAddress] = useState("bin");
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [orderType, setOrderType] = useState("order");
  const [splitScanProgress, setSplitScanProgress] = useState(null);
  const [complete, setComplete] = useState(false);
  const [show, setShow] = useState(true);

  const updateSplitScanProgress = (data = {}) => {
    const totalPackages = Number(data?.total_packages ?? 0);
    const checkedPackages = Number(data?.checked_packages ?? 0);
    const remainingPackages = Number(
      data?.remaining_packages ?? Math.max(totalPackages - checkedPackages, 0),
    );

    if (
      totalPackages === 0 &&
      checkedPackages === 0 &&
      remainingPackages === 0
    ) {
      return;
    }

    setSplitScanProgress({
      totalPackages,
      checkedPackages,
      remainingPackages,
    });
    setComplete(
      remainingPackages === 0 ||
        (totalPackages > 0 && checkedPackages >= totalPackages),
    );
  };

  const syncPackageFlowVisibility = (value = "") => {
    const shouldShowPackageFlow = !value.trim().includes("-");
    setShow(shouldShowPackageFlow);
    setComplete(false);

    if (shouldShowPackageFlow && value.trim()) {
      setSplitScanProgress(null);
    }
  };

  const resetPackageFlow = () => {
    setShow(true);
    setComplete(false);
    setSplitScanProgress(null);
  };
  var host = window.location.host;

  const checkOrderType = async (e) => {
    e.preventDefault();
    const currOrderId = Id.current.value;

    const {
      success,
      type,
      message: orderTypeMessage,
    } = await getDetectedOrderType(currOrderId);

    if (!success) {
      playErrorSound();
      setMessage(orderTypeMessage);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }
    let detectType = type === "normal" ? "order" : "return";
    setOrderType(detectType);

    if (type === "normal") {
      OrderDetails(e, currOrderId);
    } else {
      returnOrderDetails(e, currOrderId);
    }
  };
  const OrderDetails = async (e, order_id) => {
    e.preventDefault();
    try {
      const item = order_id.trim();

      const isSplitOrderId = item.includes("-");
      syncPackageFlowVisibility(item);

      let url;
      if (isSplitOrderId) {
        url = buildLink("restockOrderDetailsV2") + `&order_id=${order_id}`;
      } else {
        url = buildLink("restockOrderDetails") + `&order_id=${order_id}`;
      }

      await axiosServer.get(url).then((response) => {
        if (response.data.success) {
          if (isSplitOrderId) {
            updateSplitScanProgress(
              response?.data?.package_scan ?? response?.data?.data,
            );
          }
          playSuccessSound();
          setOrderDetails(response.data.data);
          setMessage(response.data.message);
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
        } else {
          playErrorSound();
          setMessage(response.data.message);
          setShowMessageErr(true);
          setTimeout(() => {
            setShowMessageErr(false);
          }, 3000);
        }

        if (!isSplitOrderId) {
          barcodeValue.current.focus();
        }
      });
    } catch (e) {
      playErrorSound();
      setOrderDetails(null);
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  const returnOrderDetails = async (e, return_order_id) => {
    e.preventDefault();

    try {
      const item = return_order_id.trim();

      const isSplitOrderId = item.includes("-");
      syncPackageFlowVisibility(item);

      let url;
      if (isSplitOrderId) {
        url =
          buildLink("returnOrderDetailsV2") +
          `&return_order_id=${return_order_id}`;
      } else {
        url =
          buildLink("returnOrderDetails") +
          `&return_order_id=${return_order_id}`;
      }

      const response = await axiosServer.get(url);

      if (response.data.success) {
        if (isSplitOrderId) {
          updateSplitScanProgress(
            response?.data?.package_scan ?? response?.data?.data,
          );
        }

        playSuccessSound();
        setOrderDetails(response.data.data);
        setMessage(response.data.message);
        setShowMessageSucc(true);

        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
      } else {
        playErrorSound();
        setMessage(response.data.message);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
      }

      if (!isSplitOrderId) {
        barcodeValue.current.focus();
      }
    } catch (e) {
      playErrorSound();
      setOrderDetails(null);
      setMessage(e?.response?.data?.message || "Error occurred");
      setShowMessageErr(true);

      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  const restockOrder = async (e) => {
    e.preventDefault();

    let detectedOrderType = orderType;
    let currentOrderId;
    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      currentOrderId = Id.current.value;
    } else {
      currentOrderId =
        orderType === "order"
          ? orderId.current.value
          : returnOrderId.current.value;
    }

    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      const {
        success,
        type,
        message: orderTypeMessage,
      } = await getDetectedOrderType(currentOrderId);

      if (!success) {
        playErrorSound();
        setMessage(orderTypeMessage);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        return;
      }

      detectedOrderType = type;
      let detectTypeOrder = type === "normal" ? "order" : "return";
      setOrderType(detectTypeOrder);
    }

    let endpoint;
    let order_type;
    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      endpoint =
        detectedOrderType === "normal" ? "restockOrder" : "returnOrderStatus";
      order_type = detectedOrderType === "normal" ? "order" : "return";
    } else {
      endpoint = orderType === "order" ? "restockOrder" : "returnOrderStatus";
      order_type = orderType;
    }

    if (currentOrderId === "") {
      playErrorSound();
      setMessage("Order Id is Empty!");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }

    if (adressValue.current.value === "") {
      playErrorSound();
      setMessage("Address is Empty");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }
    setLoading(true);
    const order_id = currentOrderId;
    const barcode = barcodeValue.current.value;
    const address_value = adressValue.current.value;
    const address_type = "bin";
    const user_id = stateCom.userID;

    const obj =
      order_type === "order"
        ? {
            order_id,
            barcode,
            address_value,
            address_type,
            user_id,
          }
        : {
            return_order_id: order_id,
            barcode,
            address_value,
            address_type,
            user_id,
          };

    try {
      const response = await axiosServer.post(buildLink(endpoint), obj);
      if (response.data.success) {
        playSuccessSound();
        setLoading(false);
        updateSplitScanProgress(
          response?.data?.package_scan ?? response?.data?.data,
        );
        setMessage(response.data.message);
        setShowMessageSucc(true);
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
      }
      barcodeValue.current.value = "";
      adressValue.current.value = "";
      setLoading(false);
    } catch (e) {
      playErrorSound();
      setLoading(false);
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  const history = useNavigate();
  useEffect(() => {
    if (orderType === "order") {
      orderId.current?.focus();
    } else {
      returnOrderId.current?.focus();
    }
  }, [orderType]);

  const handleOrderTrashClick = () => {
    resetPackageFlow();
    if (orderType === "order") {
      orderId.current.value = "";
      orderId.current.focus();
    } else {
      returnOrderId.current.value = "";
      returnOrderId.current.focus();
    }
  };
  const handleProductTrashClick = () => {
    barcodeValue.current.value = "";
    barcodeValue.current.focus();
  };

  const handleAddressTrashClick = () => {
    adressValue.current.value = "";
    adressValue.current.focus();
  };

  const focusAddress = (e) => {
    e.preventDefault();
    if (barcodeValue.current.value === "") {
      playErrorSound();
      setMessage("Barcode is Empty!");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }
    adressValue.current.focus();
  };

  return (
    <>
      <div className=" h-full bg-white ">
        <div className=" z-30 mb-5 sticky top-0 flex flex-col ">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl    my-auto">
                Restock Awaiting failed ready
              </h2>
            </div>
          </div>
        </div>

        <div className=" container">
          {host !== "pda.ishtari.com" &&
            !host.startsWith("localhost") &&
            host !== "pda.ishtari.com.gh" && <div className="mb-1">Order</div>}

          <div className="relative flex-1 mb-3">
            {host !== "pda.ishtari.com" &&
              !host.startsWith("localhost") &&
              host !== "pda.ishtari.com.gh" && (
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderRadius: "7px",
                      borderColor: state.isFocused ? "grey" : "grey",
                      padding: "8px 5px",
                    }),
                  }}
                  value={{
                    value: orderType,
                    label:
                      orderType.charAt(0).toUpperCase() + orderType.slice(1),
                  }}
                  onChange={(selectedOption) =>
                    setOrderType(selectedOption.value)
                  }
                  options={[
                    { value: "order", label: "Order" },
                    { value: "return", label: "Return" },
                  ]}
                  defaultValue={{ value: "order", label: "Order" }}
                  placeholder="Select Type"
                  className="w-full mb-3"
                />
              )}
            {host !== "pda.ishtari.com" &&
              !host.startsWith("localhost") &&
              host !== "pda.ishtari.com.gh" &&
              (orderType === "order" ? (
                <div className="relative flex-1">
                  <div className="mb-1">Order ID</div>

                  <input
                    ref={orderId}
                    type="text"
                    className="border border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                    placeholder="Order Id"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        OrderDetails(e, orderId?.current?.value);
                      }
                    }}
                  />

                  <div>
                    <FaTrash
                      onClick={handleOrderTrashClick}
                      className="absolute top-[55px] transform -translate-y-1/2 right-3 cursor-pointer opacity-20"
                    />
                  </div>
                </div>
              ) : (
                <div className="relative flex-1">
                  <div className="mb-1">Return Order ID</div>

                  <input
                    ref={returnOrderId}
                    type="text"
                    className="border border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                    placeholder="Return Order Id"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        returnOrderDetails(e, returnOrderId?.current?.value);
                      }
                    }}
                  />

                  <div>
                    <FaTrash
                      onClick={handleOrderTrashClick}
                      className="absolute top-[55px] transform -translate-y-1/2 right-3 cursor-pointer opacity-20"
                    />
                  </div>
                </div>
              ))}

            {(host === "pda.ishtari.com" ||
              host.startsWith("localhost") ||
              host == "pda.ishtari.com.gh") && (
              <div className="relative flex-1">
                <div className="mb-1">
                  {orderType === "order" ? "Order ID" : "Return Order ID"}
                </div>

                <input
                  ref={Id}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                  placeholder={
                    orderType === "order" ? "Order ID" : "Return Order ID"
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      checkOrderType(e);
                    }
                  }}
                />

                <div>
                  <FaTrash
                    onClick={handleOrderTrashClick}
                    className="absolute top-[55px] transform -translate-y-1/2 right-3 cursor-pointer opacity-20"
                  />
                </div>
              </div>
            )}
          </div>

          <form className=" flex flex-col gap-3 justify-center">
            {!show && splitScanProgress?.remainingPackages > 0 && (
              <div>
                <div className="p-1">Scanned:</div>
                <div className="space-x-3 flex flex-wrap">
                  <input
                    value={`${splitScanProgress.checkedPackages}/${splitScanProgress.totalPackages}`}
                    readOnly
                    type="text"
                    className="border mb-3 border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2 bg-[#f2f2f2]"
                    placeholder="Scanned"
                  />
                </div>
              </div>
            )}

            {(show || complete) && (
              <>
            <div className="relative flex-1">
              <div className="mb-1">Barcode</div>
              <input
                ref={barcodeValue}
                type="text"
                className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                placeholder="Barcode"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    focusAddress(e);
                  }
                }}
              />
              <div>
                <FaTrash
                  onClick={() => handleProductTrashClick()}
                  className="absolute top-[55px] transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
                />
              </div>
            </div>

            <div className="relative flex-1">
              <div className="mb-1">Address</div>
              <input
                ref={adressValue}
                type="text"
                className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                placeholder="Address"
                onKeyDown={(e) => {
                  if (loading) {
                    return;
                  }
                  if (e.key === "Enter") {
                    restockOrder(e);
                  }
                }}
              />
              <div>
                <FaTrash
                  onClick={() => handleAddressTrashClick()}
                  className="absolute top-[55px] transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              onClick={(e) => restockOrder(e)}
              className=" bg-dbase  px-3 py-3 text-white rounded-sm mt-3"
            >
              {" "}
              {loading
                ? "Loading..."
                : orderType === "order"
                  ? "Restock Order"
                  : "Restock Return"}
            </button>
              </>
            )}
          </form>

          {orderDetails && orderDetails.length > 0 && (
            <div className="  overflow-auto flex flex-col py-3">
              <div className=" shadow-md rounded-md">
                <div className="my-2">
                  <h2 className=" font-bold">
                    {orderType === "order" ? "Order Product" : "Return Product"}
                  </h2>
                </div>
                <table className="border-collapse text-md">
                  <thead>
                    <tr>
                      <th className="border  border-gray-400 p-2">Product</th>

                      <th className="border border-gray-400 p-2">SKU</th>
                      <th className="border border-gray-400 p-2">
                        Option Name
                      </th>
                      <th className="border border-gray-400 p-2">Address</th>
                      <th className="border border-gray-400 p-2">Reference</th>
                      <th className="border border-gray-400 p-2">Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderDetails?.map((product) => (
                      <tr>
                        <td className="border  justify-center   border-gray-400 p-2">
                          <div className=" w-fit  mx-auto">
                            <img className=" w-20" src={product.image} alt="" />
                          </div>
                        </td>

                        <td className="border border-gray-400 p-2">
                          <div className=" w-fit  mx-auto">{product.sku}</div>
                        </td>

                        <td className="border border-gray-400 p-2">
                          <div className=" w-fit  mx-auto">
                            {product.option_name}
                          </div>
                        </td>
                        <td className="border border-gray-400 p-2">
                          <div className=" w-fit  mx-auto">
                            {product.address}
                          </div>
                        </td>
                        <td className="border border-gray-400 p-2">
                          <div className=" w-fit  mx-auto">
                            {product.reference}
                          </div>
                        </td>
                        <td className="border border-gray-400 p-2">
                          <div className=" w-fit  mx-auto">
                            {product.quantity}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};

export default hocStarredPage(RestockOrder);
